// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"283":"27a1a67a","436":"0a33b8d8","926":"a239c876"}[chunkId] + ".chunk.css";
};